<template>
  <div class="loan-list">
    <div class="loan-list__table-container" id="loan-list-table-container">
      <div class="loan-list__no-data" v-if="!loanList.length">
        <NoData text="暂无贷款信息" />
      </div>
      <table v-if="loanList.length" class="loan-list__table">
        <thead>
          <tr>
            <th>订单编号</th>
            <th>订单状态</th>
            <th>产品名称</th>
            <th>所属银行</th>
            <th>下单时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="loanItem in loanList" :key="loanItem.id">
            <th>{{ loanItem.applyNo }}</th>
            <th>{{ loanItem.applyStatus | statusFilter }}</th>
            <th>{{ loanItem.productName }}</th>
            <th class="th-warp">{{ loanItem.bankName }}</th>
            <th>{{ loanItem.createTime || '2015-09-29 19:24:26' }}</th>
            <th class="options-th">
              <router-link :to="`/my/loan-detail/${loanItem.id}`">查看详情</router-link>
              <div
                v-if="curActiveOrderActionId(loanItem) === 1"
                class="link-text"
                @click="createApplyQrcode(loanItem.id, 'applyContinue')"
              >
                继续申请
              </div>
              <div
                v-if="curActiveOrderActionId(loanItem) === 2"
                class="link-text"
                @click="createApplyQrcode(loanItem.id, 'supplementData')"
              >
                补充资料
              </div>
            </th>
          </tr>
        </tbody>
      </table>
    </div>
    <Pagination @changePage="changePage" :pageSize="pageSize" :totalCount="totalCount" />
    <QrcodeDialog
      preText="该操作请在浙里办APP-浙里掌上贷完成"
      subText="请用浙里办APP扫码进行人脸识别"
      qrcodeSize="small"
      :qrcodeUrl="qrcodeUrl"
      :isShowDialog="isShowQrcodeDialog"
      @closeDialog="isShowQrcodeDialog = false"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import QrcodeDialog from '@/components/QrcodeDialog'
import NoData from '@/components/noData'
import { loanStatusMap } from '@/features/statusMap'
import { createQRcode } from '@/utils/tool'
import { getCurEnvH5Url } from '@/config/index'
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      pageSize: 10,
      isShowQrcodeDialog: false,
      qrcodeUrl: ''
    }
  },
  filters: {
    statusFilter(s) {
      return loanStatusMap.get(s) || '-'
    }
  },
  mounted() {
    this.changePage(1)
  },
  methods: {
    changePage(pageNo) {
      const loading = this.$loading({ target: '#loan-list-table-container', fullscreen: false })
      this.getLoanList({ pageNo, pageSize: this.pageSize }).then(res => {
        loading.close()
      })
    },
    curActiveOrderActionId(loanItem) {
      if (!loanItem) return
      //  草稿
      if (loanItem.applyStatus === 11) return 1
      if (loanItem.supplementFlag) return 2
    },
    async createApplyQrcode(applyId, actionType) {
      let url = getCurEnvH5Url()
      url += `/loan/?applyId=${applyId}&actionType=${actionType}`
      this.qrcodeUrl = (await createQRcode(url)) || ''
      this.isShowQrcodeDialog = true
    },
    ...mapActions('loan', ['getLoanList'])
  },
  computed: {
    ...mapState('loan', {
      loanList: state => state.loanList,
      totalCount: state => state.totalCount
    })
  },
  components: {
    Pagination,
    NoData,
    QrcodeDialog
  }
}
</script>

<style lang="scss" scoped>
.loan-list {
  margin-top: 20px;
  font-size: 14px;

  &__no-data {
    margin-top: 75px;
    margin-bottom: 20px;
  }

  &__table-container {
    min-height: 300px;
  }

  &__table {
    width: 100%;
    line-height: 1.5em;
    border-collapse: collapse;
    text-align: left;

    & thead {
      background: rgba(245, 245, 245, 1);
    }
    & th {
      white-space: nowrap;
      font-weight: 400;
      padding: 15px;
    }
    .th-warp {
      width: 100px;
      white-space: pre-wrap;
    }
    & tbody th {
      border-bottom: 1px solid #dcdfe6;
    }
  }
  &__paging {
    margin-top: 50px;
    margin-bottom: 100px;

    & /deep/ .btn-prev,
    & /deep/ .btn-next,
    & /deep/ .el-pager li {
      background-color: #fff;
      color: rgba(41, 84, 208, 1);
      border: 1px solid rgba(41, 84, 208, 1);
      border-radius: 10px;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}
.options-th {
  white-space: nowrap;

  a {
    text-decoration-line: none;
  }

  .link-text {
    display: inline-block;
    margin-left: 10px;
    color: #0000ee;
    cursor: pointer;
  }
}
</style>
